import Layout from "../(others)/layout";
import WebPageSlider from "components/WebPageSlider";
import Heading2 from "components/Heading/Heading2";
import CurvedContainer from "../../components/CurvedContainer";
import "../../styles/styles.css";

const PagePortfolio = () => {
  return (
    
      <Layout>
        <CurvedContainer>
          <header  className="text-center max-w-2xl mx-auto  sm:mb-16 lg:mb-8 ">
              <Heading2 style={{color:"black"}} className="center inline-block align-middle text-4xl font-semibold md:text-5xl">Portfolio</Heading2>
          </header>
          <WebPageSlider />
        </CurvedContainer>
      </Layout>
 

  );
};

export default PagePortfolio;
